import { GridFilterModel, GridPaginationModel, GridSortModel } from '@mui/x-data-grid';
import { Dispatch, SetStateAction } from 'react';

export const defaultOrderForV2 = {
	field: 'createdAt',
	sort: 'desc',
};

export const defaultFiltersForCache: any = [
	{
		propertyName: 'suspensionStatus',
		op: 'isAnyOf',
		value: ['Pending'],
	},
	{
		propertyName: 'terminationStatus',
		op: 'isAnyOf',
		value: ['Pending'],
	},
];

export function onSortModelChangeForCache(
	sortModel: GridSortModel,
	setPaginationModel: Dispatch<SetStateAction<GridPaginationModel>>,
	setCacheSortOrder: Dispatch<SetStateAction<any>>,
) {
	setPaginationModel((prev) => ({ ...prev, page: 0 }));
	if (!sortModel.length) {
		return setCacheSortOrder(defaultOrderForV2);
	}

	const { field, sort } = sortModel[0];
	if (!sort) return null;
	return setCacheSortOrder({
		field,
		sort,
	});
}

export const onFilterModelChangeForCache = (
	filterModel: GridFilterModel,
	setPaginationModel: Dispatch<SetStateAction<GridPaginationModel>>,
	setCacheFilters: Dispatch<SetStateAction<any>>,
) => {
	setPaginationModel((prev) => ({ ...prev, page: 0 }));

	const { items: filterItems } = filterModel;

	if (!filterItems.length) {
		setCacheFilters(defaultFiltersForCache);
		return;
	}

	const queryFilters: any = filterItems
		.map((filter) => {
			const { field, operator, value: rawValue } = filter;

			if (!rawValue && !['isEmpty', 'isNotEmpty'].includes(operator)) return [];
			let newValue = rawValue;
			if (field === 'gross' || field === 'net') {
				newValue = Number(rawValue) * 100;
			}
			return {
				propertyName: field,
				op: operator,
				value: newValue,
			};
		})
		.flat();

	if (queryFilters.length) setCacheFilters([...defaultFiltersForCache, ...queryFilters]);
};

export function capitalizeFirstLetter(str: string) {
	switch (str) {
		case null: {
			return '';
		}
		case 'termination_pending': {
			const splitStr = str.split('_');
			const string1 = splitStr[0].charAt(0).toUpperCase() + splitStr[0].slice(1);
			const string2 = splitStr[1].charAt(0).toUpperCase() + splitStr[1].slice(1);
			const final = `${string1} ${string2}`;
			return final;
		}
		default:
			return str.charAt(0).toUpperCase() + str.slice(1);
	}
}
